const animation = {
  none: {
    _hover: {
      transform: 'none',
    },
    _active: {
      transform: 'none',
    },
  },
  translate: {
    _hover: {
      transform: 'translateY(-2px)',
    },
    _active: {
      transform: 'translateY(1px)',
    },
  },
};

const button = {
  baseStyle: ({ animationType }) => ({
    borderRadius: 'xl',
    color: 'white',
    ...animation[animationType],
    _disabled: {
      _hover: {
        transform: 'none',
      },
      _active: {
        transform: 'none',
      },
    },
  }),

  sizes: {
    lg: {
      height: '16',
    },
    md: {
      height: '12',
    },
  },

  variants: {
    'primary-outline': {
      bg: 'transparent',
      borderColor: 'green.500',
      borderWidth: 1,
      borderStyle: 'solid',
      color: 'green.500',
    },

    'secondary-outline': {
      bg: 'transparent',
      borderColor: 'blue.500',
      borderWidth: 1,
      borderStyle: 'solid',
      color: 'blue.500',
    },

    'primary-link': {
      color: 'green.500',
      bg: 'transparent',
      borderWidth: 0,
    },

    'secondary-link': {
      color: 'blue.500',
      bg: 'transparent',
      borderWidth: 0,
      height: 'auto',
      width: 'auto',
      paddingInline: 0,
      fontWeight: 500,
    },

    link: {
      color: 'blue.500',
    },

    adjacentRight: {
      bg: 'blue.500',
      color: 'white',
      borderRadius: '0 10px 10px 0',
      _hover: {
        transform: 'none',
        bg: 'blue.600',
      },
      _active: {
        transform: 'none',
      },
    },

    adjacentLeft: {
      bg: 'blue.500',
      color: 'white',
      borderRadius: '10px 0 0 10px',
      _hover: {
        transform: 'none',
        bg: 'blue.600',
      },
      _active: {
        transform: 'none',
      },
    },
  },

  defaultProps: {
    animationType: 'translate',
  },
};

export default button;
